import { alpha } from '@mui/material/styles';

const MANUAL_PALETTE_DARK = {
  deepBlue: '#0d1b4b',
  blue: '#1a237e',
  black: '#0a0a0a',
  darkBg: '#111827',
  cardBg: '#1e2d4a',
  green: '#1b5e20',
  greenMid: '#2e7d32',
  greenLight: '#66bb6a',
  yellow: '#f9a825',
  yellowMid: '#fbc02d',
  white: '#ffffff',
  offWhite: '#f0f2f8',
  textPrimary: '#f5f7ff',
  textLight: '#eef1fc',
  textMuted: '#c5cae9',
  bodyText: '#e2e6f5',
  border: 'rgba(255,255,255,0.15)',
  inputBg: 'rgba(255,255,255,0.1)',
  inputBorder: 'rgba(255,255,255,0.25)',
  inputBorderHover: 'rgba(249,168,37,0.55)',
};

const MANUAL_PALETTE_LIGHT = {
  deepBlue: '#e8eaf6',
  blue: '#1a237e',
  black: '#f4f6f9',
  darkBg: '#ffffff',
  cardBg: '#ffffff',
  green: '#1b5e20',
  greenMid: '#2e7d32',
  greenLight: '#388e3c',
  yellow: '#e65100',
  yellowMid: '#f57f17',
  white: '#1a237e',
  offWhite: '#fafbfc',
  textPrimary: '#1a237e',
  textLight: '#1a237e',
  textMuted: '#455a64',
  bodyText: '#263238',
  border: 'rgba(26,35,126,0.14)',
  inputBg: '#ffffff',
  inputBorder: 'rgba(26,35,126,0.28)',
  inputBorderHover: 'rgba(230,81,0,0.55)',
};

/** @deprecated Use getManualPalette(mode) or useManualPalette() */
export const MP = MANUAL_PALETTE_DARK;

export const getManualPalette = (mode = 'dark') =>
  mode === 'light' ? MANUAL_PALETTE_LIGHT : MANUAL_PALETTE_DARK;

/** Always light-on-paper colors for the document preview pane (PDF-style). */
export const MANUAL_PREVIEW_PALETTE = {
  deepBlue: '#1a237e',
  blue: '#283593',
  black: '#ffffff',
  darkBg: '#ffffff',
  cardBg: '#ffffff',
  green: '#1b5e20',
  greenMid: '#2e7d32',
  greenLight: '#388e3c',
  yellow: '#e65100',
  yellowMid: '#f57f17',
  white: '#1a237e',
  offWhite: '#ffffff',
  textPrimary: '#1a237e',
  textLight: '#1a237e',
  textMuted: '#455a64',
  bodyText: '#263238',
  border: 'rgba(26,35,126,0.14)',
  inputBg: '#ffffff',
  inputBorder: 'rgba(26,35,126,0.28)',
  inputBorderHover: 'rgba(230,81,0,0.55)',
};

export const getPreviewPalette = () => MANUAL_PREVIEW_PALETTE;

export const getEditorInputSx = (MP) => ({
  '& .MuiOutlinedInput-root': {
    bgcolor: MP.inputBg,
    color: MP.textLight,
    '& fieldset': { borderColor: MP.inputBorder },
    '&:hover fieldset': { borderColor: MP.inputBorderHover },
    '&.Mui-focused fieldset': { borderColor: MP.yellow },
  },
  '& .MuiInputLabel-root': { color: MP.textMuted },
  '& .MuiInputLabel-root.Mui-focused': { color: MP.yellow },
  '& .MuiInputBase-input::placeholder': { color: alpha(MP.textMuted, 0.85), opacity: 1 },
});